import React from 'react';
import { UserCircle } from 'lucide-react';

const SalesTeamTab = ({ selectedUser, myTeam, teamMembers }) => {
  if (!myTeam) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-12 text-center">
        <UserCircle className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-600">No team found</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h2 className="text-xl font-bold text-gray-900 mb-4">{myTeam.team_name}</h2>
        <p className="text-gray-600 mb-4">{myTeam.description}</p>
        
        <h3 className="font-semibold text-gray-900 mb-3">Team Members ({teamMembers.length})</h3>
        <div className="space-y-2">
          {teamMembers.map(member => (
            <div key={member.id} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
              <UserCircle className="h-8 w-8 text-orange-600" />
              <div>
                <p className="font-medium text-gray-900">{member.full_name}</p>
                <p className="text-xs text-gray-600">{member.email}</p>
                {member.industries && member.industries.length > 0 && (
                  <div className="mt-1 flex flex-wrap gap-1">
                    {member.industries.map((ind, idx) => (
                      <span key={idx} className="text-xs bg-orange-100 text-orange-700 px-2 py-0.5 rounded">
                        {ind}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SalesTeamTab;
